import React, { useContext } from 'react';
import { createPortal } from 'react-dom';
import { useAbility } from '@casl/react';

import { Can, AbilityContext } from '../../abilities/Can';

import { AccountSwitcher } from '../../components/AccountSwitcher/AccountSwitcher';
import { Impersonate } from '../../components/Impersonate/Impersonate';
import { Spotlight } from '../../components/Spotlight';
import { Brandstore } from '../../components/Brandstore/Brandstore';
import { UserMenu } from '../../components/UserMenu/UserMenu';
import { AccountMenu } from '../../components/AccountMenu/AccountMenu';
import { rootHeaderTopBar } from '../../roots';
import { PublicMenu } from '../../components/PublicMenu/PublicMenu';
import { InfoContext } from '../../context';

import { TaskFeed } from '../../components/Notifications/TaskFeed';
import { NotificationCenter } from '../../components/Notifications/NotificationCenter';
import { isModule, isColdfusion } from '../../helpers/windowLocation';
import { FadeIn } from '../../components/FadeIn';
import Indicator from '../../components/OutOfOffice/indicator';
import ReplacementPortal from './ReplacementPortal';

/*
 * bynder-platform/bynder/views/navigation/topmenu.cfm
 */
function Component() {
	const ability = useAbility(AbilityContext);
	const { accounts, general } = useContext(InfoContext);
	const canShowImpersonate = ability.can('show', 'exit_impersonate');
	const canShowAccSwitcher = ability.can('show', 'account_switcher');
	const dashboardIsBeingRendered = window.document
		.querySelector('html')
		?.classList.contains('dashboard');
	const isDashboardSearchOn = dashboardIsBeingRendered && ability.can('show', 'dashboard_search');
	const showAccountSwitcher = !canShowImpersonate && (canShowAccSwitcher || accounts.length > 0);
	const showOnGuidelines = isModule('guidelines') && !isDashboardSearchOn;
	const showSpotlight =
		(!isModule('templating') && !isDashboardSearchOn && isColdfusion()) || showOnGuidelines;

	// Temporary code for replacing the coldfusion spotlight
	// so that we can remove the legacy code
	const rootNode = document.querySelector('#rootDashboardSpotlight');

	const replaceSpotlight =
		(!isModule('templating') && isDashboardSearchOn && isColdfusion()) || showOnGuidelines;

	if (ability.rules.length === 0) {
		return null;
	}

	return (
		<>
			{canShowImpersonate && <Impersonate />}

			{showAccountSwitcher && <AccountSwitcher />}

			{showSpotlight && <Spotlight />}

			{replaceSpotlight && rootNode && (
				<ReplacementPortal rootNode={rootNode}>
					<Spotlight />
				</ReplacementPortal>
			)}

			<div className="admin-right">
				{general.isPublic ? (
					<PublicMenu />
				) : (
					<>
						<Can I="show" a="notifications">
							<ul className="badges">
								<li>
									<Indicator />
								</li>

								<Can I="show" a="brandstore">
									<Brandstore />
								</Can>

								<Can I="show" a="notifications_center">
									<NotificationCenter />
								</Can>

								<Can not I="show" a="notifications_center">
									<TaskFeed />
								</Can>
							</ul>
						</Can>

						<ul className="admin-options">
							<UserMenu />
							<AccountMenu />
						</ul>
					</>
				)}
			</div>
		</>
	);
}

export function TopBar() {
	const root = document.querySelector(rootHeaderTopBar);

	if (root) {
		return createPortal(
			<FadeIn>
				<Component />
			</FadeIn>,
			root,
		);
	}

	return null;
}
